import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { default as SidebarPortal } from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';

import StringToHTML from '../../StringToHTML/StringToHTML';
import { buttonBlockSchema } from './featured_schema_enhancer';
import { emptyButtons } from './utils';
import { isEmpty } from 'lodash';

export function getTeaserImageURL(href, image) {
  let image_url = '';
  if (image) {
    if (isInternalURL(image['@id'])) {
      image_url = `${image['@id']}/@@images/image`;
    } else {
      image_url = image['@id'];
    }
  } else {
    image_url = `${href['@id']}/@@images/${href.image_field || 'preview_image'}`;
  }
  return flattenToAppURL(image_url);
}
const FeaturedView = (props) => {
  const { data, selected, onChangeBlock, block } = props;
  const HeadingTag = 'h3';
  const href = data.href?.[0];
  const image = data.preview_image?.[0];
  const [selectedButtonBlock, setSelectedButtonBlock] = useState(-1);
  const intl = useIntl();
  const properties = isEmpty(data?.buttons?.blocks)
    ? emptyButtons(1)
    : data.buttons;
  React.useEffect(() => {
    if (isEmpty(data?.buttons)) {
      onChangeBlock(block, {
        ...data,
        buttons: {
          ...properties,
        },
      });
    }
    /* eslint-disable-next-line */
  }, []);

  return (
    <div
      className="featured-overflow gradient-opacity"
      style={
        image
          ? {
              backgroundImage: `url(${getTeaserImageURL(href, image)})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }
          : {}
      }
    >
      <div
        className="featured-title-description-wrapper"
        onClick={() => setSelectedButtonBlock(-1)}
        onKeyDown={() => setSelectedButtonBlock(-1)}
        tabIndex={0}
        role="button"
      >
        <div className="featured-title-description">
          <HeadingTag>
            {data.richtitle && <StringToHTML string={data?.richtitle?.data} />}
          </HeadingTag>
          {/* <div className="featured-description">
            <h2>{data?.description2}</h2>
          </div> */}
        </div>
      </div>

      <SidebarPortal
        selected={
          selected && selectedButtonBlock !== -1 && data.buttons?.blocks
        }
      >
        <BlockDataForm
          schema={buttonBlockSchema(intl)}
          title="Button block"
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              buttons: {
                ...data.buttons,
                blocks: {
                  ...data.buttons.blocks,
                  [selectedButtonBlock]: {
                    ...data.buttons.blocks[selectedButtonBlock],
                    [id]: value,
                  },
                },
              },
            });
          }}
          formData={data.buttons?.blocks?.[selectedButtonBlock]}
        />
      </SidebarPortal>
    </div>
  );
};

export default FeaturedView;
